import { useEffect, useState } from "react";
import {
  useGetCompanysQuery,
  useLazyGetAreasByCompanyQuery,
  useLazyGetSeriesByAreaQuery,
  useLazyGetTypesBySerieQuery,
} from "../../libs/redux/slices/filterSlice/filterApiSlice";

/** Opciones unicas {label, value} de una respuesta {data: [...]} */
const opciones = (response, campoId, campoDes) => {
  const filas = response?.data?.data || [];
  return Array.from(new Set(filas.map((f) => f[campoId]))).map((valor) => ({
    value: valor,
    label: filas.find((f) => f[campoId] === valor)[campoDes],
  }));
};

/**
 * Combos en cascada empresa -> proceso -> serie -> tipo, con los mismos endpoints de la
 * pantalla de Tipo (empresaAreas, areasxseries, serieportipos).
 * @param {string} empresa  EMPNITXX seleccionado
 * @param {string} proceso  AREAIDXX seleccionado
 * @param {string} serie    SERIEIDX seleccionado
 * @returns {{empresas: Array, procesos: Array, series: Array, tipos: Array}}
 */
const useCascada = (empresa, proceso, serie) => {
  const { data: companies } = useGetCompanysQuery();
  const [triggerProcesos] = useLazyGetAreasByCompanyQuery();
  const [triggerSeries] = useLazyGetSeriesByAreaQuery();
  const [triggerTipos] = useLazyGetTypesBySerieQuery();
  const [procesos, setProcesos] = useState([]);
  const [series, setSeries] = useState([]);
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    setProcesos([]);
    if (!empresa) return;
    triggerProcesos({ EMPNITXX: empresa, AREAIDXX: "null" }).then((r) => setProcesos(opciones(r, "AREAIDXX", "AREADESX")));
  }, [empresa, triggerProcesos]);

  useEffect(() => {
    setSeries([]);
    if (!empresa || !proceso) return;
    triggerSeries({ EMPNITXX: empresa, AREAIDXX: proceso, SERIEIDX: "null" }).then((r) =>
      setSeries(opciones(r, "SERIEIDX", "SERIEDES"))
    );
  }, [empresa, proceso, triggerSeries]);

  useEffect(() => {
    setTipos([]);
    if (!empresa || !proceso || !serie) return;
    triggerTipos({ EMPNITXX: empresa, AREAIDXX: proceso, SERIEIDX: serie, TIPOIDXX: "null" }).then((r) =>
      setTipos(opciones(r, "TIPOIDXX", "TIPODESX"))
    );
  }, [empresa, proceso, serie, triggerTipos]);

  const empresas = (companies?.data || []).map((c) => ({ value: c.EMPNITXX, label: c.EMPNOMXX || c.EMPDESXX }));
  return { empresas, procesos, series, tipos };
};

export default useCascada;
